import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

import HomePage from "../src/pages/HomePage";

import ArticleList from "../src/pages/ArticleList";
import RecommendArticle from "../src/pages/RecommendArticle.vue";
// import InfiniteArticles from '../src/pages/InfiniteArticles'
import InfiniteWaterfall from "../src/pages/InfiniteArticles/Waterfall.vue";
// import SearchResult from '../src/pages/SearchResult'
// import SearchResultNew from '../src/pages/SearchResultNew'
import VideoList from "../src/pages/VideoList";
import VideoPage from "../src/pages/VideoPage";
import AuthorList from "../src/pages/AuthorList";
import AuthorPage from "../src/pages/AuthorPage";

// Events
import SpecialList from "../src/pages/Events/SpecialList";
import SpecialCategory from "../src/pages/Events/SpecialCategory";
import LectureList from "../src/pages/Events/LectureList";
import Lecture from "../src/pages/Events/Lecture";
import TrialList from "../src/pages/Events/TrialList";
import Trial from "../src/pages/Events/Trial";
import VoteList from "../src/pages/Events/VoteList";
import Vote from "../src/pages/Events/Vote";

// import PrizeDetails from '../src/pages/My/PrizeDetails'

// import Assistance from '../src/pages/Assistance.vue'
import SiteMap from "../src/pages/SiteMap";
import PrivacyPage from "../src/pages/PrivacyPage";
import NotFound from "../src/pages/NotFound";
import AboutLookin from "../src/pages/AboutLookin";

import { isLookinApp } from "../tools/bridge";

Vue.use(VueRouter);

// 鉴权
const ifAuthed = function (to, from, next) {
	if (store.getters.isAuthed) {
		// TODO: update Cookie expired time
		next();
		return;
	}

	// 这些路由登录成功后需要重新回到这些路径
	if (to.path === "/my/me") {
		next(`/?to=${to.path}`);
	} else {
		next("/");
	}

	// 弹出登录页
	store.dispatch("setLoginDrawer", true);
};

// 重定向到nuxt项目的搜索页
const gotoNuxtSearch = to => {
	const { keyword } = to.query;
	location.href = `/nuxt/search?keyword=${keyword || ""}`;
};

const routes = [
	{
		path: "/",
		name: "home",
		component: HomePage,
		meta: {
			title: "COOL SIS 酷女孩",
		},
	},
	{
		path: "/search",
		name: "search",
		beforeEnter: gotoNuxtSearch,
		// component: SearchResultNew
	},
	{
		path: "/searchV2",
		name: "search-v2",
		beforeEnter: gotoNuxtSearch,
		// component: SearchResult
	},
	{
		path: "/hot",
		name: "hot",
		component: ArticleList,
		meta: { title: "熱門文章" },
	},
	{
		path: "/new",
		name: "new",
		component: ArticleList,
		meta: { title: "最新文章" },
	},
	{
		path: "/videos",
		name: "videos",
		component: VideoList,
		meta: { title: "LOOK V 影音" },
	},
	{
		path: "/videos/:category",
		name: "videos-category",
		component: VideoList,
		beforeEnter: (to, from, next) => {
			const id = to.params.category;
			if (isNaN(id)) {
				next();
			} else {
				next({ name: "video", params: { id, title: to.params.title } });
			}
		},
	},
	{
		path: "/videos/:id",
		name: "video",
		component: VideoPage,
	},
	{
		path: "/authors",
		name: "authors",
		component: AuthorList,
		meta: { title: "駐站名人" },
	},
	{
		path: "/authors/:slug",
		name: "author",
		component: AuthorPage,
	},
	{
		path: "/specials",
		name: "specials",
		component: SpecialList,
		meta: { title: "獨家企劃" },
	},
	{
		path: "/specials/:category",
		name: "specials-category",
		component: SpecialCategory,
	},
	{
		path: "/trials",
		name: "trials",
		component: TrialList,
		meta: { title: "體驗試用" },
	},
	{
		path: "/trials/:id",
		name: "trial",
		component: Trial,
	},
	{
		path: "/lectures",
		name: "lectures",
		component: LectureList,
		meta: { title: "活動募集" },
	},
	{
		path: "/lectures/:id",
		name: "lecture",
		component: Lecture,
	},
	{
		path: "/votes",
		name: "votes",
		component: VoteList,
		meta: { title: "網友來作主" },
	},
	{
		path: "/votes/:id",
		name: "vote",
		component: Vote,
	},
	{
		path: "/sitemap",
		name: "sitemap",
		component: SiteMap,
		meta: { title: "網站總覽" },
	},
	{
		path: "/privacy",
		name: "privacy",
		component: PrivacyPage,
		meta: { title: "隱私權政策" },
	},
	{
		path: "/aboutus",
		name: "aboutus",
		component: AboutLookin,
		meta: { title: "關於我們" },
	},
	{
		path: "/choc",
		name: "choc",
		beforeEnter() {
			location.href = "https://choc.look-in.com.tw/?utm_source=lookin_desktop_menu&utm_medium=lookin_index_to_choc";
		},
	},
	{
		path: "/recommend",
		name: "recommend",
		component: RecommendArticle,
		meta: { title: "推薦" },
	},
	// {
	//   path: '/prizes/:id',
	//   name: 'prizes_details',
	//   component: PrizeDetails,
	//   meta: { title: '商品詳情' }
	// },
	{
		path: "/tag/:slug",
		name: "tag",
		component: ArticleList,
	},
	{
		path: "/ig/list",
		name: "ig_list",
		component: () => import("../src/pages/Ig/ig_list.vue"),
		meta: {
			title: "ig",
		},
	},
	{
		path: "/ig/list/item",
		name: "ig_info",
		component: () => import("../src/pages/Ig/ig_item.vue"),
		meta: {
			title: "igItem",
		},
	},
	// {
	//   path: '/fashion/luxury/:id',
	//   name: 'fashion-luxury',
	//   component: InfiniteWaterfall
	// },
	{
		path: "/articles/preview/:id",
		name: "preview",
		// component: InfiniteArticles
		component: InfiniteWaterfall,
	},
	{
		path: "/:channel",
		name: "channel",
		component: ArticleList,
	},
	{
		path: "/:channel/:sub_channel",
		name: "sub_channel",
		component: ArticleList,
	},
	{
		path: "/:channel/:sub_channel/:id",
		name: "article",
		// component: InfiniteArticles
		component: InfiniteWaterfall,
	},
	{ path: "*", component: NotFound },
];

if (isLookinApp) {
	const homeIndex = routes.findIndex(v => v.name === "home");
	/* if (homeIndex !== -1) {
    routes[homeIndex] = {
      path: '/',
      name: 'home',
      redirect: {
        name: 'recommend'
      }
    }
  } */
	const newIndex = routes.findIndex(v => v.name === "new");
	if (newIndex !== -1) {
		routes[newIndex].meta = { title: "全部文章" };
	}
}
const router = new VueRouter({
	mode: "history",
	routes,
	beforeRouteEnter(to, from, next) {
		if (to.params.title) {
			to.meta.title = to.params.title;
		}
		next();
	},
	beforeRouteUpdate(to, from, next) {
		if (to.params.title) {
			to.meta.title = to.params.title;
		}
		next();
	},
});

router.beforeEach((to, from, next) => {
	store.commit("RESET_ARTICLES");
	if (store.state.notFound404 == true) {
		store.commit("SET_404_NOT_FOUND", false);
	}
	if (store.state.serverError500 == true) {
		store.commit("SET_500_ERROR", false);
	}

	window.scrollTo(0, 0);

	/**
	 * 第三方登录新流程
	 * url上有token和user_id说明是第三方登录
	 *
	 */
	const { token = "", user_id = "", toc_user_id = "" } = to.query;
	if (token) {
		// const href = window.location.href
		const userId = user_id || toc_user_id;
		store.commit("AUTH_SUCCESS", { token, userId });
		if (!user_id) {
			// 添加统计代码，如果有token,但user_id为空，则统计
			try {
				Vue.nextTick(() => {
					setTimeout(() => {
						new TrackEvent().setEvent("not_user_id", "auto", "login", "", "");
					}, 1000);
				});
			} catch (error) {
				console.error(error);
			}
		}
	}
	next();
});

export default router;
